/**
 * Single source of truth for the homepage hero copy and the OG image variants.
 *
 * - The React hero (src/components/HeroSearch.tsx) reads from here so the live
 *   page renders the canonical copy.
 * - The build-time OG generator (scripts/generate-og.mjs) reads the SAME export
 *   so og-image*.jpg stays visually identical to the hero - even after design
 *   tweaks - because both pull from this file.
 *
 * Keep this file plain ESM so the Node script can import it directly without a
 * TypeScript build step. Avoid React/runtime imports here.
 */

export const HERO = {
  /** Trust chip shown above the headline. */
  trustChip: "Over 6,800 UK vet practices listed",
  /** H1. Keep punchy - this also becomes the OG headline. */
  headline: "Find a Vet Near You - Fast",
  /** Lead paragraph beneath the headline / on the OG image. */
  subtitle:
    "Search local veterinary practices by pet type and service. Book appointments instantly, all in one place.",
  /** Primary CTA label, mirrored on the OG image button. */
  ctaLabel: "Find Nearby Vets",
  /** Brand wordmark. */
  brand: "GetPetVet",
} as const;

/**
 * Brand tokens used by the OG renderer. These mirror the HSL values in
 * src/index.css (:root). Update both together if the brand colour changes - or
 * better, drive index.css from these constants in a future refactor.
 */
export const HERO_TOKENS = {
  primary: "#4538CC", // hsl(245 58% 51%)
  textDark: "#111827",
  textMuted: "#4B5563",
  background: "#FFFFFF",
} as const;

export type HeroConfig = typeof HERO;
export type HeroTokens = typeof HERO_TOKENS;
